const PT_MM_RATIO = 0.352778;
const mm2pt = (mm: number) => mm / PT_MM_RATIO;
export default mm2pt;
